import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Recover from stale cached builds: if a lazy chunk fails to load, reload once with fresh assets
window.addEventListener('vite:preloadError', (e) => {
  e.preventDefault();
  if (!sessionStorage.getItem('chunk-reloaded')) {
    sessionStorage.setItem('chunk-reloaded', '1');
    window.location.reload();
  }
});
setTimeout(() => sessionStorage.removeItem('chunk-reloaded'), 15000);

createRoot(document.getElementById("root")!).render(<App />);
